<template>
  <div>
    <div v-if="downtime.on_shift" class="uk-card uk-card-default uk-margin-auto uk-margin-large-top uk-padding uk-position-relative" style="width: 680px;">
<!--      <div class="uk-position-top-left">-->
<!--        <div class="uk-label tm-label" style="border-radius: 0;display: block;">Beta</div>-->
<!--        <div style="width:300px;"-->
<!--             class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"-->
<!--             data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 0; delay-show: 0; offset: 10">-->
<!--          Вы видите тестовую версию. Данные могут быть не корректными на 100%. Просьба, если вы видите неточности/расхождения передать данные администратору.-->
<!--        </div>-->
<!--      </div>-->
      <div class="uk-grid uk-flex-middle" data-uk-grid>
        <div class="uk-width-expand">
          <div class="uk-text-bold">
            {{local_page_keys.title_no_available_orders_number}} *
          </div>
          <div style="width:300px;"
               class="uk-dropdown tm-dropdown tm-dropdown-left-center uk-text-left"
               data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left; delay-hide: 0; delay-show: 0; offset: 15">
            <span v-html="local_page_keys.title_no_available_orders_number_tooltip"></span>
            <span @click="openViewVideo()" class="uk-margin-xsmall-left" style="cursor: pointer"><md-icon style="color: red">smart_display</md-icon></span>
          </div>
        </div>
        <div class="uk-width-1-6 uk-text-center uk-text-bold">
          {{computedOrdersInHour}}
        </div>
        <div class="uk-width-small uk-text-right uk-text-bold">
          {{local_page_keys.title_text_orders}}
        </div>
      </div>
      <div class="uk-grid uk-flex-middle uk-margin-small-top" data-uk-grid>
        <div class="uk-width-expand">
          <div class="uk-text-bold">
            {{local_page_keys.title_you_where_out_of_work}} *
          </div>
          <div style="width:300px;"
               class="uk-dropdown tm-dropdown tm-dropdown-left-center uk-text-left"
               data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left; delay-hide: 0; delay-show: 0; offset: 15">
            <div v-html="local_page_keys.title_you_where_out_of_work_tooltip"></div>
          </div>
        </div>
        <div class="uk-width-1-6 uk-text-center uk-text-bold">
          {{computedUserIdleTimeSeconds}}
        </div>
        <div class="uk-width-small uk-text-right uk-text-bold">
          {{local_page_keys.title_text_minutes}}
        </div>
      </div>
    </div>

    <div class="uk-margin-large-top uk-margin-auto uk-width-5-6@l uk-width-1-1">
      <div class="uk-grid uk-child-width-1-2 uk-grid-match" data-uk-grid>
        <!--ТОП опций с низким рейтингом-->
        <div>
          <div class="uk-card uk-card-default uk-padding uk-position-relative">
<!--            <div class="uk-position-top-left">-->
<!--              <div class="uk-label tm-label uk-position-relative" style="border-radius: 0;display: block;z-index: 11">Beta</div>-->
<!--              <div style="width:300px;"-->
<!--                   class="uk-dropdown tm-dropdown tm-dropdown-right-center"-->
<!--                   data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 0; delay-show: 0; offset: 15">-->
<!--                Вы видите тестовую версию. Данные могут быть не корректными на 100%. Просьба, если вы видите неточности/расхождения передать данные администратору.-->
<!--              </div>-->
<!--            </div>-->
            <div class="uk-text-center uk-position-relative" style="z-index: 11">
              <div class="uk-text-bold">
                {{local_page_keys.title_top_with_low_rate}} *
              </div>
              <div style="width:300px;"
                   class="uk-dropdown tm-dropdown tm-dropdown-bottom-center uk-text-left"
                   data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 0; delay-show: 0; offset: 10">
                <span v-html="local_page_keys.title_top_with_low_rate_tooltip"></span>
                <span  @click="openViewVideo()" class="uk-margin-xsmall-left" style="cursor: pointer"><md-icon style="color: red">smart_display</md-icon></span>
              </div>
            </div>
            <div class="uk-margin-medium-top tm-order-top-rating-box">
              <!--шаблон взят из vue-material-dashboard/src/pages/Dashboard/Tables/FunctionDescriptionTable.vue:69-->
              <template v-if="computedFunctionsListLeft && computedFunctionsListLeft.length > 0">
                <template v-for="functionsListLeftOption of computedFunctionsListLeft">
                  <div class="uk-grid uk-grid-collapse uk-text-center uk-flex-middle tm-grid-bg-hover_" data-uk-grid :key="functionsListLeftOption.name + 'Left'">
                    <!--Иконка функции-->
                    <div class="uk-width-auto">
                      <div style="width: 50px;" class="uk-padding-xsmall 1">
                        <img class="tm-func-icon" :src="functionsListLeftOption.icon" alt="">
                      </div>
                    </div>
                    <!--Название функции-->
                    <div class="uk-width-expand uk-text-left">
                      <div class="uk-padding-xsmall uk-text-truncate">
                        {{functionsListLeftOption.translated}}
                      </div>
                    </div>
                    <!--Рейтинг-->
                    <div style="width: 200px">
                      <div class="uk-padding-small">
                        <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center" data-uk-grid>
                          <div class="uk-width-expand">
                            <progress class="uk-progress" :class="'tm-progress-' + getProgressClass(functionsListLeftOption.probability_for_user)" :value="formatPercent(functionsListLeftOption.probability_for_user)" max="100"></progress>
                          </div>
                          <div class="uk-width-auto">
                            {{Math.ceil(functionsListLeftOption.average_rate_for_user_for_function_in_percentage)}} %
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

              </template>

              <hr class="uk-margin-remove">
            </div>
            <div class="uk-position-cover" style="background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 50%,rgba(255,255,255,1) 87%,rgba(255,255,255,1) 100%);"></div>
            <div class="uk-position-top-right">
              <a href="/new_mvp/functions_description?field=function_lose&type=desc" class="uk-display-block uk-background-muted uk-padding-xsmall">
                <md-icon>read_more</md-icon>
              </a>
              <div style="width:200px;"
                   class="uk-dropdown tm-dropdown tm-dropdown-left-center uk-text-center"
                   data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left; delay-hide: 0; delay-show: 0; offset: 10">
                {{local_page_keys.title_top_rate_button_tooltip}}
              </div>
            </div>
          </div>
        </div>
        <!--ТОП опций с высоким рейтингом-->
        <div>
          <div class="uk-card uk-card-default uk-padding uk-position-relative">
<!--            <div class="uk-position-top-left">-->
<!--              <div class="uk-label tm-label uk-position-relative" style="border-radius: 0;display: block;z-index: 11">Beta</div>-->
<!--              <div style="width:300px;"-->
<!--                   class="uk-dropdown tm-dropdown tm-dropdown-right-center"-->
<!--                   data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 0; delay-show: 0; offset: 15">-->
<!--                Вы видите тестовую версию. Данные могут быть не корректными на 100%. Просьба, если вы видите неточности/расхождения передать данные администратору.-->
<!--              </div>-->
<!--            </div>-->
            <div class="uk-text-center uk-position-relative" style="z-index: 11">
              <div class="uk-text-bold">
                {{local_page_keys.title_top_with_high_rate}} *
              </div>
              <div style="width:300px;"
                   class="uk-dropdown tm-dropdown tm-dropdown-bottom-center uk-text-left"
                   data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 0; delay-show: 0; offset: 10">
                <span v-html="local_page_keys.title_top_with_high_rate_tooltip"></span>
                <span  @click="openViewVideo()" class="uk-margin-xsmall-left" style="cursor: pointer"><md-icon style="color: red">smart_display</md-icon></span>
              </div>
            </div>
            <div class="uk-margin-medium-top tm-order-top-rating-box">
              <!--шаблон взят из vue-material-dashboard/src/pages/Dashboard/Tables/FunctionDescriptionTable.vue:69-->
              <template v-if="computedFunctionsListRight && computedFunctionsListRight.length > 0" >
                <template v-for="functionsListRightOption of computedFunctionsListRight">
                  <div class="uk-grid uk-grid-collapse uk-text-center uk-flex-middle tm-grid-bg-hover_" data-uk-grid :key="functionsListRightOption.name + 'Right'">
                    <!--Иконка функции-->
                    <div class="uk-width-auto">
                      <div style="width: 50px;" class="uk-padding-xsmall 2">
                        <img class="tm-func-icon" :src="functionsListRightOption.icon" alt="">
                      </div>
                    </div>
                    <!--Название функции-->
                    <div class="uk-width-expand uk-text-left">
                      <div class="uk-padding-xsmall uk-text-truncate">
                        {{functionsListRightOption.translated}}
                      </div>
                    </div>
                    <!--Рейтинг-->
                    <div style="width: 200px">
                      <div class="uk-padding-small">
                        <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center" data-uk-grid>
                          <div class="uk-width-expand">
                            <progress class="uk-progress" :class="'tm-progress-' + getProgressClass(functionsListRightOption.probability_for_user)" :value="formatPercent(functionsListRightOption.probability_for_user)" max="100"></progress>
                          </div>
                          <div class="uk-width-auto">
                            {{Math.ceil(functionsListRightOption.average_rate_for_user_for_function_in_percentage)}} %
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </template>

            </div>
            <div class="uk-position-cover" style="background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 50%,rgba(255,255,255,1) 87%,rgba(255,255,255,1) 100%);"></div>
            <div class="uk-position-top-right">
              <a href="/new_mvp/functions_description?field=function_better_than_basic&type=desc" class="uk-display-block uk-background-muted uk-padding-xsmall">
                <md-icon>read_more</md-icon>
              </a>
              <div style="width:200px;"
                   class="uk-dropdown tm-dropdown tm-dropdown-left-center uk-text-center"
                   data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left; delay-hide: 0; delay-show: 0; offset: 10">
                {{local_page_keys.title_top_rate_button_tooltip}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FunctionVideoDialog
        :show="showVideoDialog"
        @hide="showVideoDialog = false"
        v-if="showVideoDialog"
    />

  </div>

</template>

<script>
import FunctionVideoDialog from "@/pages/Dashboard/Components/Dialogs/FunctionVideoDialog";

export default {
  name: "DailyChatVersionRetoucherRatings",
  components: {FunctionVideoDialog},
  props: {
    user:{
      type: Object,
    },
    local_page_keys:{
      type: Object,
    },
    downtime: {},
  },
  data: () => ({
    sortLeft: {
      field: 'function_lose',
      type: 'desc',
      suffix: 'Left'
    },
    sortRight: {
      field: 'function_better_than_basic',
      type: 'desc',
      suffix: 'Right'
    },
    dailyChatVersionRetoucherRatings:[],
    functionsListLeft: [],
    functionsListRight: [],
    path: process.env.VUE_APP_API_URL,
    items: [],
    showVideoDialog: false,
  }),
  methods: {
    sorting(list, field, type) {
      if(list in this && this[list].length > 0){
        if (type == 'asc') {
          this[list] = this[list].sort((a, b) => {
            if(!isNaN(parseFloat(a[field])) && isFinite(a[field])) {
              a[field] = parseFloat(a[field]);
            }
            if(!isNaN(parseFloat(b[field])) && isFinite(b[field])) {
              b[field] = parseFloat(b[field]);
            }
           return (a[field] > b[field]) ? 1 : ((b[field] > a[field]) ? -1 : 0)});
        } else {
          this[list] = this[list].sort((a, b) => {
            if(!isNaN(parseFloat(a[field])) && isFinite(a[field])) {
            a[field] = parseFloat(a[field]);
          }
          if(!isNaN(parseFloat(b[field])) && isFinite(b[field])) {
            b[field] = parseFloat(b[field]);
          }
          return (b[field] > a[field]) ? 1 : ((a[field] > b[field]) ? -1 : 0)});
        }
      }

    },
    async fetchDailyChatVersionRetoucherRatings() {
      //this.isLoading = true;
      try {
        if(this.user && 'id' in this.user){
          let data = null;

          await this.$store.dispatch("order/dailyChatVersionRetoucherRatings", {user_id: this.user.id});
          data = await this.$store.getters['order/dailyChatVersionRetoucherRatings'](this.getterKey++);

          if('order_functions_list_description' in data) this.dailyChatVersionRetoucherRatings = data.order_functions_list_description

        }

      } catch (e) {
        alert(e);
      }
      this.isLoading = false;
    },
    getFirstElements(array, num = 4) {
      if (Array.isArray(array)) {
        return array.slice(0, num);
      }
      return [];
    },
    getProgressClass(value) {
      value = parseInt(value);

      if (value >= 0 && value <= 25) {
        return "grey";
      } else if (value > 25 && value <= 50) {
        return "red";
      } else if (value > 50 && value <= 64) {
        return "orange";
      } else if (value > 64 && value <= 74) {
        return "yellow";
      } else if (value > 74 && value <= 84) {
        return "light-green";
      } else if (value > 84) {
        return "green";
      } else {
        return "";
      }
    },
    formatPercent(value) {
      return parseInt(value) || 0;
    },
    openViewVideo() {
      this.showVideoDialog = true;
    },
  },
  watch: {

  },
  computed: {
    computedDailyChatVersionRetoucherRatings(){
      return  this.dailyChatVersionRetoucherRatings;
    },
    computedFunctionsListLeft(){
      return this.getFirstElements(this.functionsListLeft, 6);
    },
    computedFunctionsListRight(){
      return this.getFirstElements(this.functionsListRight, 6);
    },
    computedOrdersInHour(){
       return this.downtime && 'orders_in_hour' in this.downtime && Number(this.downtime.orders_in_hour) > 0 ? Number(this.downtime.orders_in_hour) : 0;
    },
    computedUserIdleTimeSeconds(){
      return this.downtime && 'user_idle_time_for_shift' in this.downtime && Number(this.downtime.user_idle_time_for_shift) > 0 ? Math.round(Number(this.downtime.user_idle_time_for_shift) / 60 ) : 0;
      //return this.downtime && 'user_idle_time_for_shift' in this.downtime && Number(this.downtime.user_idle_time_for_shift) > 0 ? Number(this.downtime.user_idle_time_for_shift)  : 0;
    }
  },
  async created() {
    await this.fetchDailyChatVersionRetoucherRatings();
    this.functionsListLeft = [...this.computedDailyChatVersionRetoucherRatings];
    this.functionsListRight = [...this.computedDailyChatVersionRetoucherRatings];

    await this.sorting('functionsList' + this.sortLeft.suffix, this.sortLeft.field, this.sortLeft.type);
    await this.sorting('functionsList' + this.sortRight.suffix, this.sortRight.field, this.sortRight.type);



  },
  beforeDestroy() {

  }

}
</script>

<style>

</style>